import { initialState } from './initialState';
import { BlobEditorAction, BlobEditorContext } from './types';

export const reducer = (state: BlobEditorContext, action: BlobEditorAction): BlobEditorContext => {
  switch (action.type) {
    case 'SWITCH_STEP': {
      return {
        ...state,
        step: action.payload.step
      };
    }
    case 'BLOB_IS_DIRTY': {
      return {
        ...state,
        isDirty: true
      };
    }
    case 'BLOB_SUCCESSFULLY_EDITED': {
      return {
        ...state,
        isDirty: false
      };
    }
    case 'SET_INITIAL_BLOB_DATA': {
      return {
        ...state,
        isCreator: false,
        blob: action.payload
      };
    }
    case 'CREATE_BLOB': {
      const { name, type } = action.payload;
      return {
        ...state,
        blob: {
          ...state.blob,
          name,
          type
        },
        isCreator: true
      };
    }
    case 'SET_NAME': {
      const name = action.payload;
      return {
        ...state,
        blob: {
          ...state.blob,
          name
        },
        isDirty: true
      };
    }
    case 'SET_MEDIA_FILE': {
      const mediaLibraryId = action.payload;

      return {
        ...state,
        isDirty: true,
        blob: {
          ...state.blob,
          type: state.blob.type,
          mediaLibraryId
        }
      };
    }
    case 'UPDATE_QUIZ_QUESTIONS': {
      const questions = action.payload;

      return {
        ...state,
        blob: {
          ...state.blob,
          type: state.blob.type,
          questions
        }
      };
    }
    case 'SET_LINK': {
      const url = action.payload;

      return {
        ...state,
        isDirty: true,
        blob: {
          ...state.blob,
          type: state.blob.type,
          url
        }
      };
    }
    case 'SET_TEXT': {
      const text = action.payload;

      if (state.blob.type === 'TEXT') {
        return {
          ...state,
          isDirty: true,
          blob: {
            ...state.blob,
            content: text
          }
        };
      }

      if (state.blob.type !== 'NOT_SELECTED') {
        return {
          ...state,
          isDirty: true,
          blob: {
            ...state.blob,
            description: text
          }
        };
      }

      return state;
    }

    case 'CLEAR_EDITOR_STATE': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
